import { ArrowLeft } from 'lucide-react';
import { motion } from 'motion/react';
import { MUSIC_STYLES } from '../../../lib/constants';

interface Props {
  selectedStyle: string;
  customStyle: string;
  onSelectStyle: (style: string) => void;
  onCustomStyleChange: (v: string) => void;
  onBack: () => void;
  onNext: () => void;
}

export function StepStyle({
  selectedStyle,
  customStyle,
  onSelectStyle,
  onCustomStyleChange,
  onBack,
  onNext,
}: Props) {
  const canProceed = !!selectedStyle || !!customStyle;

  return (
    <motion.div
      key="style"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      className="max-w-2xl w-full"
    >
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        Назад
      </button>

      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-8 text-center bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
        Выберите стиль музыки
      </h2>

      <div className="bg-white/80 backdrop-blur-md rounded-3xl p-4 sm:p-8 space-y-4 sm:space-y-6 shadow-xl">
        <div className="flex flex-wrap gap-3">
          {MUSIC_STYLES.map(({ name, icon }) => (
            <button
              key={name}
              onClick={() => onSelectStyle(name)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-all ${
                selectedStyle === name
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg scale-105'
                  : 'bg-white border-2 border-gray-300 text-gray-700 hover:border-purple-500'
              }`}
            >
              <span className="text-lg">{icon}</span>
              <span>{name}</span>
            </button>
          ))}
        </div>

        <div>
          <label className="block text-sm font-bold mb-2 text-gray-700">
            Свой стиль
          </label>
          <input
            type="text"
            value={customStyle}
            onChange={(e) => onCustomStyleChange(e.target.value)}
            placeholder="Опишите уникальный стиль..."
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-200 focus:outline-none text-gray-900"
          />
        </div>

        <button
          disabled={!canProceed}
          onClick={onNext}
          className="w-full px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-bold text-lg disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-lg transition-all"
        >
          Далее: Выбрать вокал
        </button>
      </div>
    </motion.div>
  );
}
